module.exports = __webpack_public_path__ + "img/0603-i.4edd49ab.svg";